export const NotFoundPage = () => {
  return (
    <>
      <main className="flex flex-col justify-center flex-auto w-full px-6 py-24 mx-auto max-w-7xl sm:py-64 lg:px-8">
        <p className="text-base font-semibold leading-8 text-slate-600">404</p>
        <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">
          Page not found
        </h1>
        <p className="mt-6 text-base leading-7 text-gray-600">
          Sorry, we couldn’t find the page you’re looking for.
        </p>
        <div className="mt-10">
          <a
            href="/"
            className="text-sm font-semibold leading-7 text-slate-600 hover:text-slate-500"
          >
            <span aria-hidden="true">&larr;</span> Back to home
          </a>
        </div>
      </main>
    </>
  );
};
